import React, { useEffect, useMemo, useState } from "react";
import formatCurrency from "../../Component/EmployeeComponents/formatCurrency";
import { BASE_URL } from "../../config/api";

export default function TeamMembersSection() {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);

  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
  const companyId = authUser?.company_id || authUser?.id ;
  const reportsTo = authUser?.id ;
  const role = authUser?.role;

  /* ================= FETCH EMPLOYEES ================= */
  const fetchEmployees = async () => {
  setLoading(true);
  try {
    // 🔹 BUILD PAYLOAD BASED ON ROLE
    const payload =
      role === 2
        ? { company_id: authUser.id }   // ✅ role = 2
        : {
            company_id: companyId,
            reports_to: reportsTo,      // ✅ other roles
          };

    const res = await fetch(`${BASE_URL}company/employee/all`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok || !data.status) {
      throw new Error(data.message || "Failed to fetch employees");
    }

    setEmployees(data.data.data || []);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchEmployees();
  }, []);

  /* ================= MAP TO UI MODEL ================= */
  const team = useMemo(() => {
    return employees.map((emp) => ({
      id: emp.id,
      owner: `${emp.first_name} ${emp.last_name}`.trim(),
      totalLeads: emp.summary?.total_leads ?? 0,
      wonDeals: emp.summary?.status_counts?.won ?? 0,
      revenue: emp.summary?.status_amounts?.won ?? 0,
      pipeline: emp.summary?.status_amounts?.in_process ?? 0,
      conversionRate: emp.summary?.conversion_rate ?? "0%",

    }));
  }, [employees]);

  /* ================= UI ================= */
  return (
    <div className="bg-white rounded-2xl border border-blue-50 shadow-sm p-4">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-semibold text-slate-900 text-sm md:text-base">
          Team Members
        </h2>
        <span className="text-[11px] text-slate-500">
          {team.length} members
        </span>
      </div>

      {loading ? (
        <div className="text-center text-sm text-slate-400 py-6">
          Loading team members…
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-3">
          {team.map((member) => {
            const initials = member.owner
              .split(" ")
              .filter(Boolean)
              .map((p) => p[0])
              .slice(0, 2)
              .join("")
              .toUpperCase();

            const winRate =
              member.totalLeads === 0
                ? 0
                : Math.round((member.wonDeals / member.totalLeads) * 100);

            return (
              <div
                key={member.id}
                className="border border-slate-300 rounded-2xl p-3 flex flex-col gap-2 bg-gradient-to-br from-white to-slate-50"
              >
                <div className="flex items-center gap-2">
                  <div className="w-9 h-9 rounded-xl bg-blue-600 text-white flex items-center justify-center text-xs font-semibold">
                    {initials}
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-slate-900">
                      {member.owner}
                    </div>
                    <div className="text-[11px] text-slate-500">
                      {member.totalLeads} leads · {member.wonDeals} won
                    </div>
                  </div>
                </div>

                <div className="flex justify-between text-[11px] text-slate-600">
                  <div>
                    <div className="text-slate-500">Won Revenue</div>
                    <div className="font-semibold text-slate-900">
                      {formatCurrency(member.revenue)}
                    </div>
                  </div>
                  <div>
                    <div className="text-slate-500">Pipeline</div>
                    <div className="font-semibold text-blue-600">
                      {formatCurrency(member.pipeline)}
                    </div>
                  </div>
                  <div>
                    <div className="text-slate-500">Win Rate</div>
                    <div className="font-semibold text-emerald-600">
                      {winRate}%
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}



// import React from "react";
// import formatCurrency from "../../Component/EmployeeComponents/formatCurrency";


// export default function TeamMembersSection({  }) {
//   const team = React.useMemo(() => {
//     const map = new Map();
//     leads.forEach((lead) => {
//       const key = lead.owner || "Unassigned";
//       if (!map.has(key)) {
//         map.set(key, {
//           owner: key,
//           totalLeads: 0,
//           wonDeals: 0,
//           revenue: 0,
//           pipeline: 0,
//         });
//       }
//       const entry = map.get(key);
//       entry.totalLeads += 1;
//       if (lead.status === "Won") {
//         entry.wonDeals += 1;
//         entry.revenue += lead.value;
//       } else if (lead.status === "In Progress") {
//         entry.pipeline += lead.value;
//       }
//     });
//     return Array.from(map.values()).sort((a, b) => b.revenue - a.revenue);
//   }, [leads]);

//   return (
//     <div className="bg-white rounded-2xl border border-blue-50 shadow-sm p-4">
//       <div className="flex items-center justify-between mb-3">
//         <h2 className="font-semibold text-slate-900 text-sm md:text-base">
//           Team Members
//         </h2>
//         <span className="text-[11px] text-slate-500">{team.length} owners</span>
//       </div>
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
//         {team.map((member) => {
//           const initials = member.owner
//             .split(" ")
//             .filter(Boolean)
//             .map((part) => part[0])
//             .slice(0, 2)
//             .join("")
//             .toUpperCase();

//           const winRate =
//             member.totalLeads === 0
//               ? 0
//               : Math.round((member.wonDeals / member.totalLeads) * 100);

//           return (
//             <div
//               key={member.owner}
//               className="border border-slate-100 rounded-2xl p-3 flex flex-col gap-2 bg-gradient-to-br from-white to-slate-50"
//             >
//               <div className="flex items-center gap-2">
//                 <div className="w-9 h-9 rounded-xl bg-blue-600 text-white flex items-center justify-center text-xs font-semibold">
//                   {initials}
//                 </div>
//                 <div>
//                   <div className="text-sm font-semibold text-slate-900">
//                     {member.owner}
//                   </div>
//                   <div className="text-[11px] text-slate-500">
//                     {member.totalLeads} leads · {member.wonDeals} won
//                   </div>
//                 </div>
//               </div>
//               <div className="flex justify-between text-[11px] text-slate-600">
//                 <div>
//                   <div className="text-slate-500">Won Revenue</div>
//                   <div className="font-semibold text-slate-900">
//                     {formatCurrency(member.revenue)}
//                   </div>
//                 </div>
//                 <div>
//                   <div className="text-slate-500">Pipeline</div>
//                   <div className="font-semibold text-blue-600">
//                     {formatCurrency(member.pipeline)}
//                   </div>
//                 </div>
//                 <div>
//                   <div className="text-slate-500">Win Rate</div>
//                   <div className="font-semibold text-emerald-600">
//                     {winRate}%
//                   </div>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }